module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/builds/eon/energieatlas/frontend/src/components/Layout/index.jsx"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"E.ON Energieatlas","short_name":"E.ON Energieatlas","start_url":"/","background_color":"#ffffff","theme_color":"#ea1b0a","display":"standalone","icons":[{"src":"/favicon-32x32.png","sizes":"32x32","type":"image/png","purpose":"any"},{"src":"/favicon-96x96.png","sizes":"96x96","type":"image/png","purpose":"any"},{"src":"/favicon-180x180.png","sizes":"180x180","type":"image/png","purpose":"any"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":null},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
